import 'react-app-polyfill/stable'
import 'core-js'
import React from 'react'
import { createRoot } from 'react-dom/client'
import ReactDOM from 'react-dom'

import App from './App'
import reportWebVitals from './reportWebVitals'
import { Provider } from 'react-redux'
import store from './store'
import { ToastContainer } from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css'
import * as serviceWorker from './serviceWorker.js'
import swConfig from './swConfig.js'
import { loadFromLocalStorage, saveToLocalStorage } from './views/services/loginService'
import { getVersion } from './views/services/commonServices'

let access_token = loadFromLocalStorage('access_token')
let returnUrl = loadFromLocalStorage('returnUrl')

if (!access_token && !returnUrl) {
  if (window.location.href.includes('#/')) {
    let rUrl = window.location.href?.substring(window.location.href.indexOf('#/') + 1)
    if (rUrl) {
      if (
        rUrl.toLowerCase() === '/mobile' ||
        rUrl.toLowerCase() === '/register' ||
        rUrl.toLowerCase() === '/login' ||
        rUrl.toLowerCase() === '/recoverpassword' ||
        rUrl.toLowerCase() === '/mobileverification'
      ) {
        //do nothing
      } else {
        saveToLocalStorage('returnUrl', rUrl)
      }
    }
  }
}

createRoot(document.getElementById('root')).render(
  <Provider store={store}>
    <ToastContainer rtl theme="colored" pauseOnHover position="bottom-left" />
    <App />
  </Provider>,
)

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
serviceWorker.register()
// serviceWorker.unregister()

// reportWebVitals()
